module.exports = __webpack_public_path__ + "img/ic-close.17e8f54b.svg";